// Shared avatar — renders a photo when `src` is present, else the initials fallback. Keeps the
// caller's existing class so each site's size/shape/colour styling is unchanged; the <img> just fills
// it (the CSS for the class should set the circle; `.has-photo` zeroes the text background). Used for
// doctor photos platform-wide (booking, profile, messaging, top-bar) and reusable for patients.
import type { CSSProperties } from "react";

export function Avatar({
  src,
  initials,
  className,
  alt = "Profile photo",
  style,
}: {
  src?: string | null;
  initials: string;
  className?: string;
  alt?: string;
  style?: CSSProperties;
}): JSX.Element {
  return (
    <span className={`cc-avatar ${src ? "has-photo" : ""} ${className ?? ""}`.trim()} style={style}>
      {src ? <img src={src} alt={alt} /> : initials}
    </span>
  );
}
